import React, { useRef, useLayoutEffect, useState } from "react";

interface AutoFitTextProps {
  text: string;
  maxFontSize?: number; // 最大字体，默认 20
  minFontSize?: number; // 最小字体，默认 12
  style?: React.CSSProperties;
}

const AutoFitText: React.FC<AutoFitTextProps> = ({
  text,
  maxFontSize = 16,
  minFontSize = 12,
  style = {},
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [fontSize, setFontSize] = useState(maxFontSize);
  const [overflow, setOverflow] = useState(false);

  const fitText = () => {
    const el = containerRef.current;
    if (!el) return;

    let currentFont = maxFontSize;
    el.style.fontSize = currentFont + "px";
    el.style.whiteSpace = "nowrap";

    while (el.scrollWidth > el.clientWidth && currentFont > minFontSize) {
      currentFont -= 1;
      el.style.fontSize = currentFont + "px";
    }

    setFontSize(currentFont);
    setOverflow(el.scrollWidth > el.clientWidth);
  };

  // 监听页面大小变化
  useLayoutEffect(() => {
    fitText();

    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver(() => fitText());
    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, [text]);

  return (
    <div
      ref={containerRef}
      style={{
        fontSize,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: overflow ? "ellipsis" : "clip",
        ...style,
      }}
    >
      {text}
    </div>
  );
};

export default AutoFitText;
